/**
 * Pure H OS · Phase D Wave 3 · OKRs (types + live view).
 * MongoDB collection: `pureh_okrs`.
 */
import { liveArray } from "../services/store";

export type OkrStatus = "on-track" | "at-risk" | "off-track" | "done";

export type OkrKpi = { label: string; target: string; current: string; progressPct: number };

export type Okr = {
  id: string;
  cycle: string;
  objective: string;
  owner: string;
  function: string;
  status: OkrStatus;
  progressPct: number;
  kpis: OkrKpi[];
};

export const OKRS: Okr[] = liveArray<Okr>("okrs");
